export default __webpack_public_path__ + "static/media/delete.2ff75d0d.svg";